import moment from 'moment';
import flatpickr from 'flatpickr';


class Datepicker {
    constructor($scope, $element) {
    const updateView = () => {
      this.pickerValue = this.model
        ? moment(this.model).format(this.format)
        : this.placeholder;
    };

    const updateModel = (selectedDates, dateStr, instance) => {
      if (this.same && this.model && moment(selectedDates[0]).isSame(this.model, this.same)) return;
      
      $scope.$apply(() => {
        this.model = selectedDates[0];
      });
      if (this.onChange) {
        this.onChange();
      }
    };

    this.$onInit = () => {
      let noCalendar;
      let enableTime;
      switch (this.mode) {
        case 'date':
          noCalendar = false;
          enableTime = false;
          this.format = ttb.constants.dateTime.DATE_FORMAT;
          this.pickerFormat = convertFormat(ttb.constants.dateTime.DATE_FORMAT, true );
          break;
        case 'time':
          noCalendar = true;
          enableTime = true;
          this.format = ttb.constants.dateTime.TIME_FORMAT;
          this.pickerFormat = convertFormat(ttb.constants.dateTime.TIME_FORMAT, false );
          break;
        default:
          noCalendar = false;
          enableTime = false;
          this.format = ttb.constants.dateTime.DATE_FORMAT;
          this.pickerFormat = convertFormat(ttb.constants.dateTime.DATE_FORMAT, true );
      }

      updateView();

      this.config = {
        noCalendar,
        enableTime,
        dateFormat: this.pickerFormat,
        time_24hr: true,
        minuteIncrement: 10,
        locale: {
          'firstDayOfWeek': 1 // start week on Monday
        },
        onClose: (selectedDates, dateStr, instance) => {
            updateModel(selectedDates, dateStr, instance);
        }
      };

        if (!this.readOnly) {
            this.instance = flatpickr($element[0].querySelector('.text-field'), this.config);
        }

      };

      this.calendarOpen = ()=> 
      {
        this.instance.open();
      }
    this.$onChanges = (changes) => {
      if (this.instance) {
        if (changes.minDate) {
          this.instance.set('minDate',moment(changes.minDate.currentValue).format(this.format));
        }
        if (changes.maxDate) {
          this.instance.set('maxDate', moment(changes.maxDate.currentValue).format(this.format));
        }
        if (changes.ngModel) { 
          updateView();
          let setDate = moment(changes.ngModel.currentValue).format(this.format);
          this.instance.set('defaultDate', setDate);
          this.instance.setDate(setDate);
        }
      }
    };


    this.$onDestroy = () => {
        if (this.instance) {
            this.instance.destroy();
        }
    };

    const convertFormat = (format, isDate) =>
    {
      if (isDate)
      {
        return format.replace(/yyyy/gi,'Y').replace(/yy/gi,'y')
                .replace(/M/,'m').replace(/mmm/gi,'M').replace(/mm/gi,'m')
                .replace(/D/,'d').replace(/ddd/gi,'D').replace(/dd/gi,'d');
      }
      else
      {
        return format.replace('HH','H').replace('hh','h').replace(/mm/gi,'i')
      }
    }
  }
}

Datepicker.$inject = ['$scope', '$element'];

export default Datepicker;


// WEBPACK FOOTER //
// ../widgets/date-time-picker/date-time-picker.controller.js